import React from 'react';
import { makeStyles } from '@material-ui/core';
import Logo from './logo.png';
import { useServiceRegistryTranslation } from '../../i18n/ServiceRegistryLanguageProvider';

const useStyles = makeStyles({
  img: {
    height: 60,
    marginTop: 4,
    width: 'auto',
  },
});

const LogoFull = () => {
  const { t } = useServiceRegistryTranslation();
  const classes = useStyles();
  return <img className={classes.img} src={Logo} alt={t('signIn.logoAlt')} />;
};

export default LogoFull;
